import React from "react";
import Translation from "../global/Translation";
import DatePicker from "react-datepicker";
import Select from "react-select";
import {defineMessages, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {setAllLinesDeliveryDates, unsetAllLinesDeliveryDates} from "../../store/cart/actions";

defineMessages({
    NOT_CHOOSE_ALL_ITEMS_DELIVERY_DATE: {
        id: 'NOT_CHOOSE_ALL_ITEMS_DELIVERY_DATE',
        description: 'NOT_CHOOSE_ALL_ITEMS_DELIVERY_DATE',
        defaultMessage: 'No, I want the products to be delivered according to the estimated delivery date'
    },
    CHOOSE_ALL_ITEMS_DELIVERY_DATE: {
        id: 'CHOOSE_ALL_ITEMS_DELIVERY_DATE',
        description: 'CHOOSE_ALL_ITEMS_DELIVERY_DATE',
        defaultMessage: 'Yes, choose the desired delivery date for all products'
    }
})



class SlaDateSelectV2 extends React.Component {

    DATE_OPTIONS = [
        {value:0, label:this.props.intl.formatMessage({id:"NOT_CHOOSE_ALL_ITEMS_DELIVERY_DATE"})},
        {value:1, label:this.props.intl.formatMessage({id:"CHOOSE_ALL_ITEMS_DELIVERY_DATE"})}
    ]

    state = {
        selectedDateOption: 0
    }

    onChangeOption = (option) => {
        if (option.value !== this.state.selectedDateOption) {
            if (option.value === 0) {
                this.props.selected && this.props.unsetAllLinesDeliveryDates()
            }
            else {
                this.props.selected && this.props.setAllLinesDeliveryDates(this.props.selected, true)
            }
            this.setState({selectedDateOption:option.value})
        }
    }

    onChangeDate = (date) => {
        this.props.setAllLinesDeliveryDates(date, true)
        this.props.onChange(date)
    }

    render() {

        return (
            <div className='checkout-cart-date'>
                <div className='title'>
                    <Translation id="want_to_change_delivery_date" defaultMessage="Do you want to modify the delivery date for all items?" />
                </div>
                {!this.props.isDisabledPreferedDeliveryDatePicker && (
                    <div className='subtitle'>
                        {'*'}<Translation id="remember_can_change_delivery_date_individually" defaultMessage="Remember that you can modify the delivery dates individually" />
                    </div>
                )}

                <div className='select' gtm-label="ec_funnel_compra_fecha_entrega_modificar">
                    <Select
                        style={{fontSize:'14px'}}
                        id="checkout__select_all_items_preferred_delivery_date"
                        className="form-control"
                        value={this.DATE_OPTIONS[this.state.selectedDateOption]}
                        onChange={this.onChangeOption}
                        options={this.DATE_OPTIONS}
                        clearable={false}
                    />
                </div>

                {
                    this.state.selectedDateOption === 1 && (
                        <div className='date'>
                            <DatePicker
                                id="all_items_sla_datepicker"
                                selected={this.props.selected}
                                onChange={date => this.onChangeDate(date)}
                                minDate={this.props.minDate}
                                className="form-control datepicker"
                                autoComplete="off"
                                onKeyDown={e => e.preventDefault()}
                                dropdownMode="select"
                            />
                            <div className='date-text'>
                                <Translation id="this_date_affects_all_items_in_your_order" defaultMessage="This date affects all items in your order." /><br/>
                                {!this.props.isDisabledPreferedDeliveryDatePicker && (
                                    <Translation id="remember_that_you_can_modify_the_delivery_dates_individually" defaultMessage="Remember that you can modify the delivery dates individually" />
                                )}
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        unsetAllLinesDeliveryDates: () => dispatch(unsetAllLinesDeliveryDates()),
        setAllLinesDeliveryDates: (deliveryDate, isDefaultDeliveryDate) => dispatch(setAllLinesDeliveryDates(deliveryDate, isDefaultDeliveryDate))
    }
}

export default injectIntl(connect(
    null,
    mapDispatchToProps
)(SlaDateSelectV2))